import { useFormContext } from "react-hook-form";

import { TextFieldProps } from "@mui/material";

import {
  selectBasicQuestions,
  useNewBusinessSelector,
} from "@covertree/new-business-redux";
import { FormSelectField } from "@covertree/ui";

import {
  HomeDetailsForm,
  skirtingOptions,
} from "../validatorsAndTypes/homeDetailsAndConstructionForm";

type Props = Omit<TextFieldProps, "variant"> & {
  name?: string;
  label?: React.ReactNode;
  placeholder?: string;
  tooltip?: string;
  fontSize?: number;
  labelFontSize?: number;
};

export function SkirtingTypeSelect({
  name = "skirtingType",
  label = "What type of skirting does the home have?",
  placeholder = "Select ...",
  tooltip = "Skirting is the material that encloses the open space between the ground and the bottom of a manufactured or mobile home. Properly installed skirting is often a requirement for coverage.",
  disabled = false,
  fontSize,
  labelFontSize,
}: Props) {
  const { skirtingType } = useNewBusinessSelector(selectBasicQuestions);

  const { control } = useFormContext<HomeDetailsForm>();

  return (
    <FormSelectField
      id="skirtingType"
      dataTestId="skirting-type-input"
      name={name}
      label={skirtingType?.label ?? label}
      tooltip={skirtingType?.tooltip ?? tooltip}
      placeholder={placeholder}
      control={control}
      options={skirtingOptions}
      optional
      disabled={disabled}
      fontSize={fontSize}
      labelFontSize={labelFontSize}
    />
  );
}
